export const LOCAL_MODEL_VIEWER_COMPOSITION_PIPELINE_KEYS = [
  'modelPosition',
  'modelScale',
  'modelRotation',
  'cameraTargetMode',
  'fixedCameraTarget',
  'cameraTargetOffset',
  'cameraViewAzimuth',
  'cameraViewElevation',
  'cameraViewDistance',
  'reflectionCloneEnabled',
] as const;

export const RENDER_PRESET_OWNED_PIPELINE_KEYS = [
  'backgroundColor',
  'showEnvironmentBackground',
  'environmentBackgroundBlur',
  'environmentRotation',
  'autoRotateModel',
  'interactionMode',
  'dragYawSensitivity',
  'autoRotateSpeed',
  'autoRotateDirection',
  'tiltMaxDeg',
  'tiltSensitivity',
  'tiltResetOnRelease',
  'toneExposure',
  'cameraViewAzimuth',
  'cameraViewElevation',
  'cameraViewDistance',
  'lighting',
  'reflectionEnabled',
  'floorShape',
  'floorReflectivity',
  'floorEdgeSoftness',
  'reflectionOpacity',
  'reflectionVisibility',
  'floorPlaneMode',
  'reflectionPlaneYOffset',
  'floorSurfacePlaneYOffset',
  'reflectorSurfaceOpacity',
  'reflectionRadiusMultiplier',
  'reflectionForwardOffsetMultiplier',
  'reflectionWidthMultiplier',
  'reflectionDepthMultiplier',
  'reflectionForegroundFade',
  'reflectionDepthFade',
  'reflectionNearBaseSharpness',
  'reflectionViewerSideSoftness',
  'reflectionResolution',
  'floorSurfaceOpacity',
  'floorColor',
  'showContactShadow',
  'shadowOpacity',
  'shadowRadiusMultiplier',
  'shadowPlaneEpsilon',
] as const;

const localCompositionKeySet = new Set<string>(LOCAL_MODEL_VIEWER_COMPOSITION_PIPELINE_KEYS);
const renderPresetOwnedKeySet = new Set<string>(RENDER_PRESET_OWNED_PIPELINE_KEYS);

export function isLocalModelViewerCompositionPipelineKey(key: string) {
  return localCompositionKeySet.has(key);
}

export function isRenderPresetOwnedPipelineKey(key: string) {
  return renderPresetOwnedKeySet.has(key);
}

export function filterModelViewerCompositionPipelineOverrides(
  value: Record<string, unknown> | undefined
): Record<string, unknown> | undefined {
  if (!value) return undefined;
  const filtered = Object.entries(value).reduce<Record<string, unknown>>((next, [key, entry]) => {
    if (isLocalModelViewerCompositionPipelineKey(key)) {
      next[key] = entry;
    }
    return next;
  }, {});
  return Object.keys(filtered).length > 0 ? filtered : undefined;
}

export function findStaleRenderPipelineOverrideKeys(
  value: Record<string, unknown>,
  prefix = ''
) {
  return Object.keys(value)
    .filter(
      (key) =>
        isRenderPresetOwnedPipelineKey(key) ||
        !isLocalModelViewerCompositionPipelineKey(key)
    )
    .map((key) => `${prefix}${key}`);
}
